import React from "react";

const InfoCircleIcon = ({ size = 25, color = "#1EB24B", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 3.97852V1.97852H15.5V3.97852H9.5ZM11.5 14.9785H13.5V8.97852H11.5V14.9785ZM12.5 22.9785C11.2667 22.9785 10.1042 22.741 9.0125 22.266C7.92083 21.791 6.96667 21.1452 6.15 20.3285C5.33333 19.5118 4.6875 18.5577 4.2125 17.466C3.7375 16.3743 3.5 15.2118 3.5 13.9785C3.5 12.7452 3.7375 11.5827 4.2125 10.491C4.6875 9.39935 5.33333 8.44518 6.15 7.62852C6.96667 6.81185 7.92083 6.16602 9.0125 5.69102C10.1042 5.21602 11.2667 4.97852 12.5 4.97852C13.5333 4.97852 14.525 5.14518 15.475 5.47852C16.425 5.81185 17.3167 6.29518 18.15 6.92852L19.55 5.52852L20.95 6.92852L19.55 8.32852C20.1833 9.16185 20.6667 10.0535 21 11.0035C21.3333 11.9535 21.5 12.9452 21.5 13.9785C21.5 15.2118 21.2625 16.3743 20.7875 17.466C20.3125 18.5577 19.6667 19.5118 18.85 20.3285C18.0333 21.1452 17.0792 21.791 15.9875 22.266C14.8958 22.741 13.7333 22.9785 12.5 22.9785Z"
      fill={color}
    />
  </svg>
);

export default InfoCircleIcon;
